import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import isEqual from 'lodash.isequal';
import FileUpload from '@rd-web-markets/shared/dist/util/FileUpload';
import { useFileUpload } from '@rd-web-markets/shared/dist/hooks';
import { useTranslation } from 'react-i18next';
import omit from 'lodash.omit';
const ProjectOwnerTableData = _ref => {
  let {
    isSaved,
    setIsSaved,
    notSavedStyle,
    body,
    setBody,
    saveData,
    rowData,
    uploadFile,
    deleteData,
    createNewData,
    uploadAllowed,
    setUploadAllowed,
    removeEmptyRow,
    emptyRowId,
    projectReports
  } = _ref;
  const [file, isFileUploadLoading, setFile] = useFileUpload(!!body.id ? uploadFile : createNewData, 'document', uploadAllowed);
  const {
    t
  } = useTranslation();
  const changeBody = e => {
    const key = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const finalValue = ['project_working_time', 'actual_working_time'].includes(key) && !!value.length ? Number(value) : value;
    if ((e.target.type === 'checkbox' || key === 'year') && !!rowData.id) {
      if (key === 'fulltime' && value === true) {
        //reset specific data to original when fulltime is checked
        const fulltimeBody = {
          ...body,
          [key]: finalValue,
          digital_record: rowData.digital_record,
          project_working_time: rowData.project_working_time,
          actual_working_time: rowData.actual_working_time
        };
        setBody({
          ...fulltimeBody
        });
        saveData(fulltimeBody);
      } else {
        saveData({
          ...body,
          [key]: finalValue
        });
        setBody({
          ...body,
          [key]: finalValue
        });
      }
      return;
    }
    setBody({
      ...body,
      [key]: finalValue
    });
  };
  const filenameLink = rowData.document ? /*#__PURE__*/React.createElement("a", {
    href: rowData.document.url,
    target: "_blank",
    rel: "noreferrer"
  }, rowData.document.filename) : /*#__PURE__*/React.createElement("p", null, t('no_file_has_been_uploaded'));
  const submit = () => {
    if (!!rowData.id) {
      saveData(body);
    } else if (!file) {
      createNewData(new FormData());
    } else {
      setUploadAllowed(true);
    }
  };
  const saveOnBlur = () => {
    submit();
  };
  useEffect(() => {
    //if current state is similar to rowData, isSaved should be FALSE
    isEqual(omit(body, ['document']), omit(rowData, ['document'])) ? setIsSaved(true) : setIsSaved(false);
  }, [body, rowData, setIsSaved]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    style: isSaved ? {} : notSavedStyle
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: body.name,
    onBlur: saveOnBlur,
    name: "name",
    onChange: changeBody,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "year",
    onChange: changeBody,
    onBlur: saveOnBlur,
    size: "md",
    value: body.year
  }, /*#__PURE__*/React.createElement("option", {
    key: 'year_after_project',
    value: 'after_30_06_2020'
  }, t('after_30_06_2020')), /*#__PURE__*/React.createElement("option", {
    key: 'year_before_project',
    value: 'before_01_07_2020'
  }, t('before_01_07_2020')))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "bda",
    checked: body.bda,
    onBlur: saveOnBlur,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "fulltime",
    checked: body.fulltime,
    onBlur: saveOnBlur,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    className: "text-start",
    type: "checkbox",
    name: "digital_record",
    disabled: body.fulltime,
    checked: body.fulltime ? false : body.digital_record,
    onBlur: saveOnBlur,
    onChange: changeBody
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
    name: "project_working_time",
    disabled: body.fulltime,
    value: body.fulltime ? 0 : body.project_working_time,
    onChange: changeBody,
    onBlur: saveOnBlur,
    size: "md",
    style: {
      height: 'inherit'
    },
    type: "number",
    role: "input-number",
    min: 0
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
    name: "actual_working_time",
    disabled: body.fulltime,
    value: body.fulltime ? 0 : body.actual_working_time,
    onChange: changeBody,
    onBlur: saveOnBlur,
    size: "md",
    style: {
      height: 'inherit'
    },
    type: "number",
    role: "input-number",
    min: 0
  })), /*#__PURE__*/React.createElement("td", null, filenameLink), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FileUpload, {
    disabled: !body.id,
    loading: isFileUploadLoading,
    title: t('upload_document'),
    file: file,
    onSelectFile: setFile
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteButton, {
    style: {
      marginRight: '8px'
    },
    onClick: () => emptyRowId !== null ? removeEmptyRow(emptyRowId) : deleteData(body),
    "data-testid": "delete_button"
  }))));
};
export default ProjectOwnerTableData;